import { Button, Icon } from "@trimble/modus-cmx";
import { lazy, Suspense, useState } from "react";
import { useTranslation } from "react-i18next";
import { AskNovaLauncher } from "./styled";

const AskNovaChatPanel = lazy(() => import("./AskNovaChatPanel"));

const AskNovaChatbot = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {!isOpen ? (
        <AskNovaLauncher>
          <Button
            variant="outlined"
            color="neutral"
            shape="rectangle"
            aria-label={t("ask_nova.launch")}
            onButtonClick={() => {
              setIsOpen(true);
            }}
          >
            {t("ask_nova.launch")}
            <Icon name="chat" aria-hidden size="sm" />
          </Button>
        </AskNovaLauncher>
      ) : null}

      {isOpen ? (
        <Suspense fallback={null}>
          <AskNovaChatPanel
            onClose={() => {
              setIsOpen(false);
            }}
          />
        </Suspense>
      ) : null}
    </>
  );
};

export default AskNovaChatbot;
